import React, { useEffect, useState } from "react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { useNavigate } from "react-router-dom";

export default function ExploreCategories() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api({
          url: SummaryApi.homeCategoryPreview.url,
          method: SummaryApi.homeCategoryPreview.method,
        });

        setCategories(res?.data?.data || []);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <section className="container mx-auto mb-12 px-4">
      <div className="text-center">

        {/* Heading */}
        <h2 className="text-4xl md:text-5xl mb-4 font-times text-black">
          Explore Our Property Categories
        </h2>

        <p className="text-[#64748B] max-w-3xl mx-auto mb-12">
          Discover the perfect plot for your needs in the heart of Kerala,
          from lush plantations to strategic commercial spaces.
        </p>

        {/* DESKTOP */}
        <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((item, i) => (
            <div 
              key={i}
              onClick={() =>navigate(`/properties?category=${item.category.replace(/\s+/g, "-")}`)}
              className="relative rounded-2xl overflow-hidden group"
            >

              {/* IMAGE */}
              <img
                src={item.heroImage?.url}
                alt={item.title}
                className="w-full h-[420px] object-cover group-hover:scale-105 transition duration-300"
              />

              {/* OVERLAY */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

              {/* TEXT */}
              <div className="absolute bottom-4 left-4 right-4 text-left text-white">

                <p className="text-sm uppercase tracking-wide text-white">
                  {item.category?.trim()}
                </p>

                <h3 className="text-sm font-semibold mt-1">
                  {item.title?.trim()}
                </h3>

                <p className="text-xs opacity-90 mt-1 text-[#FFFFFFCC]">
                  {item.tagline?.trim()}
                </p>

              </div>
            </div>
          ))}
        </div>

        {/* MOBILE */}
        <div className="md:hidden flex gap-4 overflow-x-auto px-2 pb-4">
          {categories.map((item, i) => (
            <div
              key={i}
              onClick={() =>navigate(`/properties?category=${item.category.replace(/\s+/g, "-")}`)}
              className="relative min-w-[70%] max-w-[260px] rounded-xl overflow-hidden flex-shrink-0"
            >

              <img
                src={item.heroImage?.url}
                alt={item.title}
                className="w-full h-[200px] object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>

              <div className="absolute bottom-3 left-3 right-3 text-white text-left">
                <p className="text-[10px] text-[#A3E635] uppercase">
                  {item.category?.trim()}
                </p>

                <h3 className="text-sm font-semibold mt-1">
                  {item.title?.trim()}
                </h3>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
}